import useOperationSummary from '../../Hooks/useOperationSummary';
import useWorkOrders, { WorkOrderSummary } from './useWorkOrders';
import {
  OperationSummaryError,
  OperationSummaryParams
} from '../../Components/types';

interface UseWorkOrdersSummaryReturn {
  loading: boolean;
  workOrders: WorkOrderSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadWorkOrders: () => Promise<void>;
  errors?: OperationSummaryError | null;
}

const useWorkOrdersSummary = (
  params?: OperationSummaryParams
): UseWorkOrdersSummaryReturn => {
  const { getSummaryWorkOrders } = useWorkOrders();

  const {
    loading,
    items: workOrders,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadWorkOrders,
    errors
  } = useOperationSummary<WorkOrderSummary>(
    'workOrdersSummary',
    getSummaryWorkOrders,
    params,
    'workOrdersSummary'
  );

  return {
    loading,
    workOrders,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadWorkOrders,
    errors
  };
};

export default useWorkOrdersSummary;
